/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from "immer";
import {
  LOADER_STATUS,
  PROFILE_INFO,
  SET_VARIANCE_DATA,
  SET_CLEAR_GRAPH,
  SET_AGG_CASH_TOTAL_DATA,
  SET_AGG_ITC_TOTAL_DATA,
  SET_GSTIN_CASH_DATA,
  SET_GSTIN_ITC_DATA,
  SET_LED_ITC_BAL_DATA,
  SET_RET_PER_DATA
} from "./constants";

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  profileData: [],
  varianceData: [],
  aggCashTotalData: [],
  aggITCTotalData: [],
  gstinWiseCashData: [],
  gstinWiseITCData: [],
  ledgerITCbalanceTrendData: [],
  returnPeriodData: []
};

/* eslint-disable default-case, no-param-reassign */
const LedgerBalanceAnalysisReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus
      };
    case PROFILE_INFO:
      return {
        ...state,
        profileData: action.profileData
      };
    case SET_VARIANCE_DATA:
      return {
        ...state,
        varianceData: action.varianceData
      };
    case SET_AGG_CASH_TOTAL_DATA:
      return {
        ...state,
        aggCashTotalData: action.aggCashTotalData
      };
    case SET_AGG_ITC_TOTAL_DATA:
      return {
        ...state,
        aggITCTotalData: action.aggITCTotalData
      };
    case SET_GSTIN_CASH_DATA:
      return {
        ...state,
        gstinWiseCashData: action.gstinWiseCashData
      };
    case SET_GSTIN_ITC_DATA:
      return {
        ...state,
        gstinWiseITCData: action.gstinWiseITCData
      };
    case SET_LED_ITC_BAL_DATA:
      return {
        ...state,
        ledgerITCbalanceTrendData: action.ledgerITCbalanceTrendData
      };
    case SET_RET_PER_DATA:
      return {
        ...state,
        returnPeriodData: action.returnPeriodData
      };
    case SET_CLEAR_GRAPH:
      return {
        ...state,
        aggCashTotalData: [],
        aggITCTotalData: [],
        gstinWiseCashData: [],
        gstinWiseITCData: [],
        ledgerITCbalanceTrendData: [],
        returnPeriodData: []
      };
    default:
      return state;
  }
};

export default LedgerBalanceAnalysisReducer;
